export default __webpack_public_path__ + "static/media/2cd43b_e1762ed5d54a431b868a924379c3e059_mv2.2e1b6964.png";